const DAY_MS = 1000 * 60 * 60 * 24;

// get number of days remaining
export function daysRemaining(validTo: string) {
	const date = new Date(validTo);
	const currentDate = new Date(new Date().setHours(0, 0, 0, 0));
	const diff = date.getTime() - currentDate.getTime();

	return Math.floor(diff / DAY_MS);
}
